// git add --a
// git push origin NewServer
import { useState, useEffect, useRef, useCallback, useLayoutEffect } from "react";
import IconSelectionFilere from "./Composents/Icon_Selection_filiere";
import IconSelectionCritere from "./Composents/Icon_Selection_Critère";
import HomeSousCritere from "./Composents/Home_Sous_Critere";
import Navbar2 from "./Composents/Navbar2";
import axios from 'axios';
import { useLocation } from 'react-router-dom';
import React from 'react';
import SalesforceGlobalErrors from './Composents/SalesforceGlobalErrors';
import { ExchangeIntroDialog, ExchangeIntroMessage } from './Composents/ExchangeIntroduction';
import {
    applySalesforceErrors,
    clearSalesforceErrors,
    stripSalesforceErrors,
    scrollToQuestion
} from './shared/salesforceClientErrors';
const {
    buildQuestionLookup,
    getVisibleSousCritereEntries,
    hasRequiredAlternanceAcceptance,
    isQuestionVisible,
    recalculateProgressForDossier,
    synchronizeQuestionVisibility
} = require('./shared/progress');

const { introductionFromMessages } = require('./shared/exchangeIntroduction');

const TEMPLATE_MESSAGES_API_URL = '/backend/api/templates';
const INTRO_MESSAGES_ACK_API_URL = '/backend/api/dossier/intro-messages/ack';
const ALLOWED_MESSAGE_COLORS = ['#ef7c7a', '#efbd4d', '#6fb88b'];
const EMPTY_DOSSIER_RELOAD_DELAY_MS = 2000;
const EMPTY_DOSSIER_RELOAD_STORAGE_PREFIX = 'psi_empty_dossier_reload_';

function getEmptyDossierReloadStorageKey(etudiant) {
    return EMPTY_DOSSIER_RELOAD_STORAGE_PREFIX + (etudiant || 'unknown');
}

function scheduleEmptyDossierReloadOnce(etudiant) {
    const storageKey = getEmptyDossierReloadStorageKey(etudiant);

    try {
        if (window.sessionStorage.getItem(storageKey) === '1') {
            return;
        }
        window.sessionStorage.setItem(storageKey, '1');
    } catch {
        if (window.__psiEmptyDossierReloadScheduled) {
            return;
        }
        window.__psiEmptyDossierReloadScheduled = true;
    }

    window.setTimeout(() => {
        window.location.reload();
    }, EMPTY_DOSSIER_RELOAD_DELAY_MS);
}

function clearEmptyDossierReloadMarker(etudiant) {
    try {
        window.sessionStorage.removeItem(getEmptyDossierReloadStorageKey(etudiant));
    } catch {
        window.__psiEmptyDossierReloadScheduled = false;
    }
}

const INTRO_CONFIRMATION_POPUP = {
    fr: "Confirmez-vous avoir bien lu les messages précédents ?\n\nCliquez sur OK pour continuer ou Annuler pour relire.",
    en: "Do you confirm that you have read the previous messages?\n\nClick OK to continue or Cancel to read them again."
};

const ESTIMATION_TEST_OVERRIDE_DEADLINE = new Date(2026, 5, 1, 0, 0, 0, 0);
const DISTINCT_CONTACT_EMAIL_MESSAGES = {
    139: "L'adresse e-mail du responsable légal doit être différente de celle de l'étudiant et du garant.",
    319: "L'adresse e-mail du garant doit être différente de celle de l'étudiant et du responsable légal."
};

// Une candidature porte jusqu'à trois filières (vœux) envoyées séparément :
// elle n'est close que lorsque toutes sont transmises. Une inscription l'est
// dès sa filière soumise.
function isDossierSoumis(dossier) {
    if (!Array.isArray(dossier?.data)) return false;
    if (dossier.configuration === 'Candidature') {
        return dossier.data.length > 0 && dossier.data.every((entry) => entry.soumis === true);
    }
    return dossier.data.some((entry) => entry.soumis === true);
}

function normalizeTemplateMessageList(list, fallback) {
    const hasList = Array.isArray(list);
    const source = hasList ? list : fallback;
    const normalized = source
        .map((entry, index) => {
            const item = entry && typeof entry === 'object' ? entry : {};
            const fallbackItem = fallback[index] || {};
            const text = (typeof item.text === 'string' ? item.text.trim() : '') || fallbackItem.text || '';
            if (!text) return null;
            const colorRaw = typeof item.backgroundColor === 'string' ? item.backgroundColor.trim().toLowerCase() : '';
            const fallbackColor = ALLOWED_MESSAGE_COLORS.includes(String(fallbackItem.backgroundColor || '').toLowerCase())
                ? String(fallbackItem.backgroundColor).toLowerCase()
                : '#efbd4d';
            const backgroundColor = ALLOWED_MESSAGE_COLORS.includes(colorRaw)
                ? colorRaw
                : fallbackColor;
            const id = (typeof item.id === 'string' && item.id.trim())
                ? item.id.trim()
                : `${fallbackItem.id || 'message'}_${index + 1}`;
            return { id, text, backgroundColor };
        })
        .filter(Boolean);

    if (normalized.length > 0 || hasList) {
        return normalized;
    }
    return fallback;
}

function normalizeTemplateMessages(payload) {
    const messages = payload && typeof payload === 'object' ? payload : {};
    return {
        intro: normalizeTemplateMessageList(messages.intro, []),
        final: normalizeTemplateMessageList(messages.final, [])
    };
}

function App() {

    /* ------------------------------------------------------------ STATE ------------------------------------------------------------ */

    const [data, setData] = useState(null);
    const [etudiant, setEtudiant] = useState([]);

    const [EtudToken] = useState([]);
    const [token, setToken] = useState();
    const [mail, setMail] = useState();
    const [candidature, setCandidature] = useState();
    const [isAuthorized, setIsAuthorized] = useState(false);
    const [isValidatingToken, setIsValidatingToken] = useState(true);
    const [registrationConfiguration, setRegistrationConfiguration] = useState(null);
    const location = useLocation();

    const [filieres, setFilieres] = useState([]);
    const [criteres, setCriteres] = useState([]);
    const [souscritereactif, setSouscritere] = useState([]);

    const [filiere, setFiliere] = useState("");
    const [niveau, setNiveau] = useState("");
    const [getNumberFiliereActif, setNumberFiliereActif] = useState();

    const [getMainActifNum, setMainActifNum] = useState(0);
    const [getNumberCritereActif, setNumberCritereActif] = useState(0);
    const [getNumberSousCritereActif, setNumberSousCritereActif] = useState(0);
    const [estimationTestSelection, setEstimationTestSelection] = useState({ niveau: "", filiere: "" });
    const isEstimationTestWindowOpen = new Date() < ESTIMATION_TEST_OVERRIDE_DEADLINE;

    const [getHomeActif, setHomeActif] = useState("HomeSousCritere NoActif");
    const [getFiliereActif, setFiliereActif] = useState("MenuSelectionFiliere");
    const [getCritereActif, setCritereActif] = useState("MenuSelectionCritere NoActif");
    const [getBtnRetourActif, setBtnRetourActif] = useState("btnRetour NoActif");
    const [getBtnSoumissionActif, setBtnSoumissionActif] = useState("btnRetour NoActif");
    const [getBtnSoumissionDossier, setBtnSoumissionDossier] = useState("");
    //const [getClassTitreFiliereActif, setClassTitreFiliereActif] = useState("NoActif");
    const [getClassDossierSoumisActif, setClassDossierSoumisActif] = useState("NoActif");
    const [isDisabled, setIsDisabled] = useState(true);
    const [paymentExists, setPaymentExists] = useState(null);


    const [sendToCrmValue, setsendToCrmValue] = useState('');
    // Erreurs du CRM non rattachables à une question précise (règles internes
    // du CRM, dossier déjà transmis, service injoignable) : affichées en tête.
    const [salesforceGlobalErrors, setSalesforceGlobalErrors] = useState([]);
    const langRef = useRef("fr");
    const isExchange = data?.configuration === 'Echange' || registrationConfiguration === 'Echange';
    langRef.current = isExchange ? 'en' : (data?.lang || 'fr');
    const [templateMessages, setTemplateMessages] = useState({ intro: [], final: [] });
    const [templateMessagesStatus, setTemplateMessagesStatus] = useState('loading');
    const [templateMessagesAttempt, setTemplateMessagesAttempt] = useState(0);
    const [hasValidatedIntroMessages, setHasValidatedIntroMessages] = useState(false);
    const [exchangeIntroduction, setExchangeIntroduction] = useState(() => introductionFromMessages());
    const [introDialogOpen, setIntroDialogOpen] = useState(false);
    const [isSavingIntroValidation, setIsSavingIntroValidation] = useState(false);

    const navPendingRef = useRef(false);
    const isRestoringRef = useRef(false);
    const lastNavStateRef = useRef(null);
    const pendingPopStateRef = useRef(null);

    const recordNav = useCallback(() => {
        navPendingRef.current = true;
    }, []);

    const buildNavState = useCallback(() => {
        return {
            main: getMainActifNum,
            filiere: typeof getNumberFiliereActif === "number" ? getNumberFiliereActif : 0,
            critere: typeof getNumberCritereActif === "number" ? getNumberCritereActif : 0,
            sousCritere: typeof getNumberSousCritereActif === "number" ? getNumberSousCritereActif : 0
        };
    }, [getMainActifNum, getNumberFiliereActif, getNumberCritereActif, getNumberSousCritereActif]);

    const clampValue = useCallback((value, min, max) => {
        return Math.min(Math.max(value, min), max);
    }, []);

    const normalizeNavState = useCallback((rawState) => {
        if (!rawState) {
            return null;
        }

        const mainRaw = typeof rawState.main === "number" ? rawState.main : 0;
        const filiereRaw = typeof rawState.filiere === "number" ? rawState.filiere : 0;
        const critereRaw = typeof rawState.critere === "number" ? rawState.critere : 0;
        const sousCritereRaw = typeof rawState.sousCritere === "number" ? rawState.sousCritere : 0;

        if (!data || !Array.isArray(data.data) || data.data.length === 0) {
            return {
                main: clampValue(mainRaw, 0, 4),
                filiere: filiereRaw,
                critere: critereRaw,
                sousCritere: sousCritereRaw
            };
        }

        const filiereMax = data.data.length - 1;
        const filiere = clampValue(filiereRaw, 0, filiereMax);
        const criteresList = data.data[filiere]?.criteres || [];
        const critereMax = Math.max(criteresList.length - 1, 0);
        const critere = clampValue(critereRaw, 0, critereMax);
        const sousList = criteresList[critere]?.sousCriteres || [];
        const sousMax = Math.max(sousList.length - 1, 0);
        const sousCritere = clampValue(sousCritereRaw, 0, sousMax);

        return {
            main: clampValue(mainRaw, 0, 4),
            filiere,
            critere,
            sousCritere
        };
    }, [data, clampValue]);

    const isSameNavState = useCallback((stateA, stateB) => {
        if (!stateA || !stateB) {
            return false;
        }
        return (
            stateA.main === stateB.main &&
            stateA.filiere === stateB.filiere &&
            stateA.critere === stateB.critere &&
            stateA.sousCritere === stateB.sousCritere
        );
    }, []);

    const renderInformativeMessages = useCallback((messages) => {
        if (!Array.isArray(messages)) return null;
        return messages.map((message) => (
            <section
                className="menuCritere menuMessageTemplate"
                style={{
                    backgroundColor: message.backgroundColor || '#efbd4d',
                    '--ices-message-accent': ({ '#ef7c7a': '#b93b38', '#efbd4d': 'var(--ices-orange)', '#6fb88b': '#419d66' })[message.backgroundColor] || 'var(--ices-orange)'
                }}
                key={message.id || message.text}
            >
                <h3 className="MessageInformatifText">
                    {(message.text || '').split("\n").map((line, idx) => (
                        <React.Fragment key={`${message.id || 'msg'}_${idx}`}>
                            {line}
                            <br />
                        </React.Fragment>
                    ))}
                </h3>
            </section>
        ));
    }, []);

    useEffect(() => {
        const isIntroMessagesStep = isAuthorized
            && !hasValidatedIntroMessages
            && !isDossierSoumis(data);

        document.body.classList.toggle("introMessagesStep", isIntroMessagesStep);

        return () => {
            document.body.classList.remove("introMessagesStep");
        };
    }, [isAuthorized, hasValidatedIntroMessages, data]);

    useEffect(() => {
        let activePreview = null;

        const closePreview = () => {
            if (!activePreview) return;

            const { overlay, image, originRect, keyDownHandler, previousBodyOverflow } = activePreview;
            activePreview = null;

            document.removeEventListener("keydown", keyDownHandler);
            document.body.style.overflow = previousBodyOverflow;

            overlay.classList.remove("questionHelpImageLightbox--open");
            image.style.left = `${originRect.left}px`;
            image.style.top = `${originRect.top}px`;
            image.style.width = `${originRect.width}px`;
            image.style.height = `${originRect.height}px`;

            window.setTimeout(() => {
                overlay.remove();
            }, 260);
        };

        const openPreview = (sourceImage) => {
            if (activePreview) {
                closePreview();
            }

            const originRect = sourceImage.getBoundingClientRect();
            const overlay = document.createElement("div");
            const image = document.createElement("img");
            const previousBodyOverflow = document.body.style.overflow;

            overlay.className = "questionHelpImageLightbox";
            image.className = "questionHelpImageLightbox__image";
            image.src = sourceImage.currentSrc || sourceImage.src;
            image.alt = sourceImage.alt || "";
            image.style.left = `${originRect.left}px`;
            image.style.top = `${originRect.top}px`;
            image.style.width = `${originRect.width}px`;
            image.style.height = `${originRect.height}px`;

            const keyDownHandler = (event) => {
                if (event.key === "Escape") {
                    closePreview();
                }
            };

            overlay.addEventListener("click", (event) => {
                if (event.target === overlay) {
                    closePreview();
                }
            });
            image.addEventListener("click", closePreview);

            overlay.appendChild(image);
            document.body.appendChild(overlay);
            document.body.style.overflow = "hidden";
            document.addEventListener("keydown", keyDownHandler);

            activePreview = { overlay, image, originRect, keyDownHandler, previousBodyOverflow };

            window.requestAnimationFrame(() => {
                const viewportWidth = window.innerWidth;
                const viewportHeight = window.innerHeight;
                const ratio = sourceImage.naturalWidth && sourceImage.naturalHeight
                    ? sourceImage.naturalWidth / sourceImage.naturalHeight
                    : Math.max(originRect.width, 1) / Math.max(originRect.height, 1);
                let targetWidth = viewportWidth * 0.9;
                let targetHeight = targetWidth / ratio;

                if (targetHeight > viewportHeight * 0.86) {
                    targetHeight = viewportHeight * 0.86;
                    targetWidth = targetHeight * ratio;
                }

                image.style.left = `${(viewportWidth - targetWidth) / 2}px`;
                image.style.top = `${(viewportHeight - targetHeight) / 2}px`;
                image.style.width = `${targetWidth}px`;
                image.style.height = `${targetHeight}px`;
                overlay.classList.add("questionHelpImageLightbox--open");
            });
        };

        const handleClick = (event) => {
            const sourceImage = event.target.closest?.(".QuestionHelpUpload img");
            if (!sourceImage) return;

            event.preventDefault();
            event.stopPropagation();
            openPreview(sourceImage);
        };

        document.addEventListener("click", handleClick);

        return () => {
            document.removeEventListener("click", handleClick);
            closePreview();
        };
    }, []);

    const handleIntroValidation = useCallback(async (exchangeConfirmed = false) => {
        if (isSavingIntroValidation) return;

        if (isExchange && exchangeConfirmed !== true) {
            setIntroDialogOpen(true);
            return;
        }
        const confirmed = isExchange || window.confirm(
            langRef.current === "en" ? INTRO_CONFIRMATION_POPUP.en : INTRO_CONFIRMATION_POPUP.fr
        );
        if (!confirmed) {
            return;
        }

        setIsSavingIntroValidation(true);

        try {
            if (token) {
                const response = await axios.post(INTRO_MESSAGES_ACK_API_URL, { token });
                const introMessagesReadAt = response?.data?.introMessagesReadAt;
                if (introMessagesReadAt) {
                    setData((prev) => {
                        if (!prev || typeof prev !== 'object') return prev;
                        return {
                            ...prev,
                            introMessagesReadValidated: true,
                            introMessagesReadAt
                        };
                    });
                }
            }
        } catch (error) {
            // On laisse l'accès même en cas d'erreur de sauvegarde pour ne pas bloquer l'étudiant.
        } finally {
            setIntroDialogOpen(false);
            setHasValidatedIntroMessages(true);
            setIsSavingIntroValidation(false);
        }
    }, [isSavingIntroValidation, token, isExchange]);

    const normalizeEmailForComparison = useCallback((value) => {
        return String(value || "").trim().toLowerCase();
    }, []);

    const isComparableEmail = useCallback((value) => {
        const normalizedValue = normalizeEmailForComparison(value);
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(normalizedValue);
    }, [normalizeEmailForComparison]);

    const setQuestionBaseValideFormat = useCallback((question, value) => {
        if (!question) {
            return;
        }

        if (Object.prototype.hasOwnProperty.call(question, "baseValideFormat")) {
            question.baseValideFormat = value;
            return;
        }

        Object.defineProperty(question, "baseValideFormat", {
            value,
            writable: true,
            configurable: true,
            enumerable: false
        });
    }, []);

    const applyDistinctContactEmailValidation = useCallback((dossierData) => {
        if (!dossierData || !Array.isArray(dossierData.data)) {
            return false;
        }

        let changed = false;
        const studentMail = normalizeEmailForComparison(dossierData.mail ?? mail);

        dossierData.data.forEach((period) => {
            const emailQuestions = {};
            const dataFiltres = Array.isArray(period?.filtres) ? period.filtres : [];
            const questionLookup = buildQuestionLookup(period);

            getVisibleSousCritereEntries(period).forEach(({ sousCritere }) => {
                (sousCritere?.questions || []).forEach((question) => {
                    if (question?.id === 139 || question?.id === 319) {
                        emailQuestions[question.id] = question;
                    }
                });
            });

            [139, 319].forEach((questionId) => {
                const question = emailQuestions[questionId];
                if (!question) {
                    return;
                }

                const hasBaseValideFormat = Object.prototype.hasOwnProperty.call(question, "baseValideFormat");
                const baseValideFormat = hasBaseValideFormat ? question.baseValideFormat : question.valideFormat;
                if (!hasBaseValideFormat) {
                    setQuestionBaseValideFormat(question, question.valideFormat);
                    changed = true;
                }

                const isCurrentQuestionVisible = isQuestionVisible(question, {
                    dataFiltres,
                    questionLookup
                });
                const currentEmail = isCurrentQuestionVisible
                    ? normalizeEmailForComparison(question.value)
                    : "";
                const otherQuestion = emailQuestions[questionId === 139 ? 319 : 139];
                const isOtherQuestionVisible = otherQuestion
                    ? isQuestionVisible(otherQuestion, {
                        dataFiltres,
                        questionLookup
                    })
                    : false;
                const otherEmail = isOtherQuestionVisible
                    ? normalizeEmailForComparison(otherQuestion?.value)
                    : "";
                const hasDuplicate =
                    isCurrentQuestionVisible
                    && isComparableEmail(currentEmail)
                    && (
                        (isComparableEmail(studentMail) && currentEmail === studentMail)
                        || (isComparableEmail(otherEmail) && currentEmail === otherEmail)
                    );

                const nextValidationMessage = hasDuplicate
                    ? DISTINCT_CONTACT_EMAIL_MESSAGES[questionId]
                    : undefined;
                const nextValideFormat = hasDuplicate ? false : baseValideFormat;

                if (question.validationMessage !== nextValidationMessage) {
                    if (nextValidationMessage) {
                        question.validationMessage = nextValidationMessage;
                    } else {
                        delete question.validationMessage;
                    }
                    changed = true;
                }

                if (question.valideFormat !== nextValideFormat) {
                    question.valideFormat = nextValideFormat;
                    changed = true;
                }
            });
        });

        return changed;
    }, [mail, normalizeEmailForComparison, isComparableEmail, setQuestionBaseValideFormat]);


    /* ------------------------------------------------------------ COMPORTEMENT ------------------------------------------------------------ */


    /* --- RÉCUPÉRATION TOKEN DANS PARAMÈTRE URL --- */

    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const urlToken = queryParams.get('tkn');
        setIsValidatingToken(true);
        if (urlToken) {
            axios.post('/backend/api/validate-token', { token: urlToken })
                .then(response => {
                    setRegistrationConfiguration(response.data.configuration || null);
                    //console.log(response);
                    if (response.data.success) {
                        clearEmptyDossierReloadMarker(urlToken);
                        setIsAuthorized(true);
                        setEtudiant(urlToken);
                        setToken(urlToken);
                        setMail(response.data.mail);
                        setCandidature(response.data.candidature);
                    } else {
                        setIsAuthorized(false);
                        scheduleEmptyDossierReloadOnce(urlToken);
                        //console.warn(response.data.message);
                    }
                })
                .catch(error => {
                    setRegistrationConfiguration(error.response?.data?.configuration || null);
                    //console.error('Erreur lors de la validation du token :', error);
                    setIsAuthorized(false);
                    scheduleEmptyDossierReloadOnce(urlToken);
                }).finally(() => setIsValidatingToken(false));
        } else {
            setIsValidatingToken(false);
            setIsAuthorized(false);
        }
    }, [location, EtudToken, candidature]);

    useEffect(() => {
        if (!data?.configuration) return;
        let isCancelled = false;
        setTemplateMessagesStatus('loading');

        const fetchTemplateMessages = async () => {
            try {
                const response = await fetch(`${TEMPLATE_MESSAGES_API_URL}/${data.configuration.toLowerCase()}/messages`);
                if (!response.ok) throw new Error('Chargement des messages impossible');
                const payload = await response.json();
                if (!payload.success || !Array.isArray(payload.messages?.intro)
                    || !Array.isArray(payload.messages?.final)) {
                    throw new Error('Messages du formulaire invalides');
                }
                if (isCancelled) return;
                setTemplateMessages(normalizeTemplateMessages(payload.messages));
                if (data.configuration === 'Echange') setExchangeIntroduction(introductionFromMessages(payload.messages));
                setTemplateMessagesStatus('ready');
            } catch (error) {
                if (!isCancelled) setTemplateMessagesStatus('error');
            }
        };

        fetchTemplateMessages();
        return () => {
            isCancelled = true;
        };
    }, [templateMessagesAttempt, data?.configuration]);

    useEffect(() => {
        setHasValidatedIntroMessages(false);
        setIntroDialogOpen(false);
    }, [token]);

    useEffect(() => {
        setEstimationTestSelection({ niveau: "", filiere: "" });
    }, [token]);

    useEffect(() => {
        const handlePopState = (event) => {
            const navState = event.state && event.state.__psiNav;
            if (!navState) {
                return;
            }

            const normalized = normalizeNavState(navState);
            if (!normalized || !data || !Array.isArray(data.data)) {
                pendingPopStateRef.current = navState;
                return;
            }

            isRestoringRef.current = true;
            setMainActifNum(normalized.main);
            setNumberFiliereActif(normalized.filiere);
            setNumberCritereActif(normalized.critere);
            setNumberSousCritereActif(normalized.sousCritere);
        };

        window.addEventListener("popstate", handlePopState);
        return () => window.removeEventListener("popstate", handlePopState);
    }, [data, normalizeNavState]);

    useEffect(() => {
        if (!pendingPopStateRef.current) {
            return;
        }
        if (!data || !Array.isArray(data.data)) {
            return;
        }

        const normalized = normalizeNavState(pendingPopStateRef.current);
        pendingPopStateRef.current = null;
        if (!normalized) {
            return;
        }

        isRestoringRef.current = true;
        setMainActifNum(normalized.main);
        setNumberFiliereActif(normalized.filiere);
        setNumberCritereActif(normalized.critere);
        setNumberSousCritereActif(normalized.sousCritere);
    }, [data, normalizeNavState]);

    useEffect(() => {
        if (!isAuthorized || !data || !Array.isArray(data.data)) {
            return;
        }
        if (lastNavStateRef.current) {
            return;
        }
        const state = normalizeNavState(buildNavState()) || buildNavState();
        const baseState = window.history.state && typeof window.history.state === "object" ? window.history.state : {};
        window.history.replaceState({ ...baseState, __psiNav: state }, "");
        lastNavStateRef.current = state;
    }, [isAuthorized, data, buildNavState, normalizeNavState]);

    useEffect(() => {
        if (!isAuthorized || !data || !Array.isArray(data.data)) {
            return;
        }

        if (isRestoringRef.current) {
            const state = normalizeNavState(buildNavState()) || buildNavState();
            lastNavStateRef.current = state;
            isRestoringRef.current = false;
            navPendingRef.current = false;
            return;
        }

        if (!navPendingRef.current) {
            return;
        }

        navPendingRef.current = false;
        const state = normalizeNavState(buildNavState()) || buildNavState();
        if (isSameNavState(state, lastNavStateRef.current)) {
            return;
        }

        const baseState = window.history.state && typeof window.history.state === "object" ? window.history.state : {};
        window.history.pushState({ ...baseState, __psiNav: state }, "");
        lastNavStateRef.current = state;
    }, [getMainActifNum, getNumberFiliereActif, getNumberCritereActif, getNumberSousCritereActif, isAuthorized, data, buildNavState, normalizeNavState, isSameNavState]);


    /* --- RÉCUPÉRATION NIVEAU ET FILIÈRE --- */


    useEffect(() => {
        try {
            setFiliere(filieres[getNumberFiliereActif].nom);
            setNiveau(filieres[getNumberFiliereActif].niveau);
        } catch {
            setFiliere("");
        }
    }, [filieres, getNumberFiliereActif]);




    /* --- GESTION DES CHANGEMENTS DE PAGES --- */
    useEffect(() => {
        const verifyPayment = async () => {
            if (!token) return;

            const exists = await checkPaymentExists(token);
            setPaymentExists(exists);
        };

        verifyPayment();
    }, [token]);

    useEffect(() => {


        if (getMainActifNum === 0) {
            setHomeActif("HomeSousCritere NoActif");
            setFiliereActif("MenuSelectionFiliere");
            setCritereActif("MenuSelectionCritere NoActif");
            setBtnRetourActif("btnRetour NoActif");
            setBtnSoumissionActif("btnRetour NoActif");
            //setClassTitreFiliereActif("NoActif");
            setClassDossierSoumisActif("NoActif");
        } else if (getMainActifNum === 1) {
            setHomeActif("HomeSousCritere NoActif");
            setFiliereActif("MenuSelectionFiliere NoActif");
            setCritereActif("MenuSelectionCritere");
            setBtnRetourActif("btnRetour");
            setBtnSoumissionActif("btnRetour");
            //setClassTitreFiliereActif("");
            setClassDossierSoumisActif("NoActif");
            if (paymentExists || ['Candidature', 'Echange'].includes(data?.configuration)) {
                if (langRef.current === "en") {
                    setBtnSoumissionDossier("Submit my file")
                } else {
                    setBtnSoumissionDossier("Validation du dossier")
                }
            } else {
                if (langRef.current === "en") {
                    setBtnSoumissionDossier("Pay")
                } else {
                    setBtnSoumissionDossier("Validation du dossier")
                }
            }
        } else if (getMainActifNum === 2) {
            setHomeActif("HomeSousCritere");
            setFiliereActif("MenuSelectionFiliere NoActif");
            setCritereActif("MenuSelectionCritere NoActif");
            setBtnRetourActif("btnRetour NoActif");
            setBtnSoumissionActif("btnRetour NoActif");
            setClassDossierSoumisActif("NoActif");
            if (data?.data?.[getNumberFiliereActif]?.criteres?.[getNumberCritereActif]?.id === 50) {
                setBtnRetourActif("btnRetour");
                setBtnSoumissionActif("btnRetour NoActif");
                if (langRef.current === "en") {
                    setBtnSoumissionDossier("Submit my file")
                } else {
                    setBtnSoumissionDossier("Envoyer mon dossier")
                }
            }
        } else if (getMainActifNum === 3) {
            setHomeActif("HomeSousCritere NoActif");
            setFiliereActif("MenuSelectionFiliere NoActif");
            setCritereActif("MenuSelectionCritere NoActif");
            setBtnRetourActif("btnRetour NoActif");
            setBtnSoumissionActif("btnRetour NoActif");
            setClassDossierSoumisActif("");
            if (data?.data?.[getNumberFiliereActif]?.criteres?.[getNumberCritereActif]?.id === 50) {
                setBtnRetourActif("btnRetour NoActif");
                setBtnSoumissionActif("btnRetour NoActif");
                if (langRef.current === "en") {
                    setBtnSoumissionDossier("Submit my file")
                } else {
                    setBtnSoumissionDossier("Validation du dossier")
                }
            }
        } else if (getMainActifNum === 4) {
            setHomeActif("HomeSousCritere NoActif");
            setFiliereActif("MenuSelectionFiliere NoActif");
            setCritereActif("MenuSelectionCritere NoActif");
            setBtnRetourActif("btnRetour NoActif");
            setBtnSoumissionActif("btnRetour NoActif");
            //setClassTitreFiliereActif("");
            if (langRef.current === "en") {
                setBtnSoumissionDossier("Submit my file");
            } else {
                setBtnSoumissionDossier("Validation du dossier");
            }
            setClassDossierSoumisActif("NoActif");

        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [getMainActifNum, getNumberCritereActif]);

    /* --- MISE À JOUR DES POURCENTAGES DE PROGRESSION --- */


    const updatePercentage = useCallback((dataPayload, baseData) => {
        const base = Array.isArray(dataPayload)
            ? (baseData && !Array.isArray(baseData) ? baseData : {})
            : (dataPayload || {});
        const periods = Array.isArray(dataPayload)
            ? dataPayload
            : (dataPayload?.data || []);

        const nextData = {
            ...base,
            token: token,
            mail: mail,
            candidature: candidature,
            lang: langRef.current,
            data: periods.map((period, periodIndex) => {
                return {
                    ...period,
                    filtres: period?.filtres || base?.data?.[periodIndex]?.filtres || [],
                    criteres: (period.criteres || []).map((critere) => {
                        return {
                            ...critere,
                            sousCriteres: (critere.sousCriteres || []).map((sousCritere) => {
                                return {
                                    ...sousCritere,
                                    questions: (sousCritere.questions || []).map((question) => ({
                                        ...question
                                    }))
                                };
                            })
                        };
                    })
                };
            })
        };

        synchronizeQuestionVisibility(nextData);
        recalculateProgressForDossier(nextData);
        return nextData;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [token, mail, candidature]);


    function setQuestionValueToTrue(data, questionId) {
        data.data.forEach(item => { // Correction ici : data.data
            item.criteres.forEach(critere => {
                critere.sousCriteres.forEach(sousCritere => {
                    sousCritere.questions.forEach(question => {
                        if (question.id === questionId) {
                            question.value = true;
                            //console.log(`Question ID ${questionId} mise à jour avec value=true`);
                        }
                    });
                });
            });
        });
    }


    const dataRef = useRef(data);
    useEffect(() => {
        dataRef.current = data;
    }, [data]);



    /* --- ENVOIE DE CHAQUE MODIFICATION D'UN DOSSIER DANS SERVER POUR MISE À JOUR DU JSON --- */


    // Empreinte des données qui comptent pour le dossier (réponses, filtres,
    // sous-critères vus). Les pourcentages et la visibilité en sont exclus :
    // ils sont recalculés, et les modifier seuls ne justifie pas un envoi.
    const saveSignature = useCallback((dossier) => {
        if (!dossier || !Array.isArray(dossier.data)) return null;
        return JSON.stringify(dossier.data.map((period) => [
            period?.filtres,
            (period?.criteres || []).map((critere) => (critere?.sousCriteres || []).map((sousCritere) => [
                sousCritere?.vue === true,
                (sousCritere?.questions || []).map((question) => [
                    question?.id,
                    question?.value,
                    question?.valueName,
                    question?.code_postal,
                    question?.valideFormat,
                    question?.valideFormatConfirm
                ])
            ]))
        ]));
    }, []);

    // Dernière version confirmée côté serveur (ou chargée depuis lui).
    const savedSignatureRef = useRef(null);
    // Un seul envoi à la fois : sans cela, deux envois simultanés pouvaient
    // arriver dans le désordre et l'ancien écraser le récent.
    const saveQueueRef = useRef({ running: null, queued: null, latest: null });

    const sendDataToServer = useCallback((updatedData) => {
        if (updatedData == null || (updatedData.configuration === 'Echange' && updatedData.data?.some(entry => entry.soumis))) return Promise.resolve(false);
        const queue = saveQueueRef.current;
        queue.latest = updatedData;
        if (!queue.queued) {
            queue.queued = (queue.running || Promise.resolve()).then(() => {
                queue.queued = null;
                // On envoie l'état le plus récent reçu entre-temps.
                const toSend = queue.latest;
                const signature = saveSignature(toSend);
                const run = axios.post('/backend/update-json', {
                    etudiant,
                    // Les erreurs renvoyées par le CRM sont un état d'affichage, pas
                    // une donnée du dossier : on les retire avant l'enregistrement.
                    newData: stripSalesforceErrors(toSend)
                })
                    .then((response) => {
                        savedSignatureRef.current = signature;
                        // Candidature : l'établissement a ajouté ou retiré des
                        // filières. Les réponses reconnues sont enregistrées ;
                        // la liste affichée est périmée, on recharge.
                        if (response?.data?.dossierModifie) {
                            window.alert(response.data.message);
                            window.location.reload();
                            return false;
                        }
                        return true;
                    })
                    .catch(() => false);
                queue.running = run;
                return run;
            });
        }
        return queue.queued;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [etudiant, saveSignature]);

    const triggerSave = useCallback(() => {
        if (dataRef.current) {
            return sendDataToServer(dataRef.current);
        }
        return Promise.resolve(false);
    }, [sendDataToServer]);

    // Enregistrement automatique peu après chaque modification : les réponses
    // et les sous-critères vus ne dépendent plus d'un clic sur un bouton de
    // navigation (retour navigateur, F5, fermeture de l'onglet les perdaient).
    useEffect(() => {
        if (!data || !Array.isArray(data.data) || data.configuration === 'Echange') return undefined;
        if (savedSignatureRef.current === null) return undefined;
        if (saveSignature(data) === savedSignatureRef.current) return undefined;
        const timer = setTimeout(() => {
            triggerSave();
        }, 1500);
        return () => clearTimeout(timer);
    }, [data, saveSignature, triggerSave]);

    // Dernier envoi quand la page est masquée ou quittée. `keepalive` permet à
    // la requête d'aboutir après la fermeture ; au-delà de sa limite de taille
    // (64 Ko), on retombe sur l'envoi normal.
    useEffect(() => {
        const flush = () => {
            const current = dataRef.current;
            if (!current || !Array.isArray(current.data) || current.configuration === 'Echange') return;
            if (savedSignatureRef.current === null) return;
            if (saveSignature(current) === savedSignatureRef.current) return;
            const signature = saveSignature(current);
            const body = JSON.stringify({ etudiant, newData: stripSalesforceErrors(current) });
            try {
                fetch('/backend/update-json', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body,
                    keepalive: true
                })
                    .then((response) => {
                        if (response.ok) savedSignatureRef.current = signature;
                    })
                    .catch(() => sendDataToServer(current));
            } catch (error) {
                sendDataToServer(current);
            }
        };
        const handleVisibility = () => {
            if (document.visibilityState === 'hidden') flush();
        };
        document.addEventListener('visibilitychange', handleVisibility);
        window.addEventListener('pagehide', flush);
        return () => {
            document.removeEventListener('visibilitychange', handleVisibility);
            window.removeEventListener('pagehide', flush);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [etudiant, saveSignature, sendDataToServer]);

    /**
     * Envoi d'une candidature vers le CRM (API REST, côté serveur).
     *
     * Rend true si le CRM a accepté le dossier — lui seul autorise alors le
     * passage à l'écran final. En cas de refus, les champs fautifs sont
     * signalés sur le formulaire et le candidat y est ramené.
     *
     * Remplace Web-to-Case pour les candidatures uniquement.
     */
    const submitCandidatureToCrm = useCallback(async () => {
        setSalesforceGlobalErrors([]);

        // Le dossier est enregistré avant l'envoi : si le CRM refuse, les
        // réponses saisies ne sont pas perdues.
        const saved = dataRef.current && await sendDataToServer(dataRef.current);
        if (!saved) {
            setSalesforceGlobalErrors([{
                message: "Vos dernières modifications n’ont pas pu être enregistrées. L’envoi est interrompu pour éviter de transmettre d’anciennes réponses. Merci de réessayer.",
                fixable: false
            }]);
            return false;
        }

        let response;
        try {
            // Seule la filière affichée est envoyée, dans son propre vœu.
            const entry = dataRef.current?.data?.[getNumberFiliereActif];
            response = await axios.post(
                '/backend/salesforce/candidature/submit',
                { token, entryIndex: getNumberFiliereActif, voeu: entry?.voeu || null, filiere: entry?.nom || '' },
                { validateStatus: () => true }
            );
        } catch (error) {
            setSalesforceGlobalErrors([{
                message: "Le serveur est injoignable. Merci de vérifier votre connexion et de réessayer.",
                fixable: false
            }]);
            return false;
        }

        const body = response.data || {};

        if (response.status === 200 && body.success) {
            // Accepté : on efface d'éventuelles erreurs précédentes.
            // Les autres filières gardent leur état : elles s'envoient à leur tour.
            setData((previous) => {
                if (!previous) return previous;
                const next = clearSalesforceErrors(JSON.parse(JSON.stringify(previous)));
                const entry = next.data?.[getNumberFiliereActif];
                if (entry) {
                    entry.soumis = true;
                    if (body.voeu) entry.voeu = body.voeu;
                }
                return next;
            });
            setFilieres((previous) => previous.map((item, index) => (
                index === getNumberFiliereActif ? { ...item, soumis: true } : item
            )));
            return true;
        }

        // Filières modifiées par l'établissement depuis l'ouverture de la page.
        if (response.status === 409 && body.dossierModifie) {
            window.alert(body.message);
            window.location.reload();
            return false;
        }

        // Dossier déjà transmis : on ne recrée pas de Demande.
        if (response.status === 409) {
            setSalesforceGlobalErrors([{
                message: body.message || 'Ce dossier a déjà été transmis.',
                fixable: false
            }]);
            return false;
        }

        // Refus : on place les erreurs sur les questions concernées.
        const errors = Array.isArray(body.errors) ? body.errors : [];
        let outcome = { applied: 0, orphans: errors, firstLocation: null, blocking: [] };

        setData((previous) => {
            if (!previous) return previous;
            const next = clearSalesforceErrors(JSON.parse(JSON.stringify(previous)));
            outcome = applySalesforceErrors(next, errors, getNumberFiliereActif);
            return next;
        });

        // Erreurs que le candidat ne peut pas corriger seul : celles qui ne
        // visent aucune question, et celles qui en visent une mais relèvent du
        // CRM. Toutes sont reprises en tête de page, avec invitation à nous
        // contacter — sinon le candidat corrigerait en boucle sans comprendre.
        const globals = [...outcome.orphans, ...(outcome.blocking || [])].map((error) => ({
            message: error.message || body.message || "Votre dossier n'a pas pu être transmis.",
            detail: error.detail || (error.nom ? `Champ concerné : ${error.nom}.` : ''),
            fixable: false
        }));
        if (!errors.length && body.message) {
            globals.push({ message: body.message, fixable: false });
        }
        setSalesforceGlobalErrors(globals);

        // Ramène le candidat au premier champ corrigeable.
        if (outcome.firstLocation) {
            setMainActifNum(2);
            setNumberCritereActif(outcome.firstLocation.critereIndex);
            setNumberSousCritereActif(outcome.firstLocation.sousCritereIndex);
            scrollToQuestion(outcome.firstLocation.questionId);
        } else {
            // Aucune erreur corrigeable : on reste sur l'écran de confirmation
            // où le message global est visible.
            setMainActifNum(3);
        }

        return false;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [token, getNumberFiliereActif, sendDataToServer]);

    // Auto-save after 5 minutes of ACTIVE page time (visible + focused)
    useEffect(() => {
        let activeMs = 0;
        let lastTick = Date.now();

        const tick = () => {
            const now = Date.now();
            const isActive = document.visibilityState === "visible" && document.hasFocus();
            if (isActive) {
                activeMs += (now - lastTick);
                if (activeMs >= 5 * 60 * 1000) {
                    triggerSave();
                    activeMs = 0;
                }
            }
            lastTick = now;
        };

        const interval = setInterval(tick, 10 * 1000);

        const handleVisibilityChange = () => {
            lastTick = Date.now();
        };

        document.addEventListener("visibilitychange", handleVisibilityChange);
        window.addEventListener("focus", handleVisibilityChange);
        window.addEventListener("blur", handleVisibilityChange);

        return () => {
            clearInterval(interval);
            document.removeEventListener("visibilitychange", handleVisibilityChange);
            window.removeEventListener("focus", handleVisibilityChange);
            window.removeEventListener("blur", handleVisibilityChange);
        };
    }, [triggerSave]);

    useEffect(() => {
        if (etudiant.length !== 0) {
            const fetchJson = async () => {
                try {
                    const response = await fetch(`/backend/api/json/Etudiants/${etudiant}.json`);
                    if (!response.ok) {
                        throw new Error(`Erreur HTTP : ${response.status}`);
                    }
                    const json = await response.json();
                    applyDistinctContactEmailValidation(json);
                    // Point de départ de l'enregistrement automatique : rien à
                    // renvoyer tant que le candidat n'a rien modifié.
                    savedSignatureRef.current = saveSignature(json);
                    setData(json);

                    if (json.data && Array.isArray(json.data) && json.data.length > 0) {
                        clearEmptyDossierReloadMarker(etudiant);
                        setFilieres(json.data.map(filiere => ({
                            id: filiere.id,
                            period: filiere.period,
                            nom: filiere.nom,
                            niveau: filiere.niveau,
                            soumis: filiere.soumis
                        })));
                    } else {
                        setFilieres([]);
                        scheduleEmptyDossierReloadOnce(etudiant);
                    }
                } catch (error) {
                    scheduleEmptyDossierReloadOnce(etudiant);
                    //console.error('Impossible de récupérer le fichier JSON :', error);
                }
            };
            fetchJson();
        }
    }, [etudiant, applyDistinctContactEmailValidation, saveSignature]);

    function checkPaymentExists(token) {
        return axios.post('/backend/verify-payment', { token })
            .then(response => {
                return response.status === 200; // Retourne true si le fichier existe
            })
            .catch(error => {
                //console.error('Erreur lors de la vérification du paiement:', error);
                return false; // Retourne false en cas d'erreur
            });
    }

    async function disabledBoutonSoumission() {
        if (data?.configuration === 'Echange') {
            if (data.data?.some(entry => entry.soumis)) return true;
            const sections = getVisibleSousCritereEntries(data.data?.[getNumberFiliereActif])
                .filter(({ critere }) => Number(critere.id) !== 50);
            return !sections.length || sections.some(({ sousCritere }) => Number(sousCritere.pourcentage) !== 100);
        }
        let dis = false;
        //console.log("disabledBoutonSoumission")
        if (getMainActifNum === 2 && data?.data?.[getNumberFiliereActif]?.criteres?.[getNumberCritereActif]?.id === 50) {
            //console.log("data.data[getNumberFiliereActif].criteres[getCritereActif].id")
            //console.log(data.data[getNumberFiliereActif].criteres[getNumberCritereActif].id)
            if (!hasRequiredAlternanceAcceptance(data.data[getNumberFiliereActif])) {
                return true;
            }
            if (!token) {
                return true;
            }
            if (paymentExists === null) {
                return !(await checkPaymentExists(token));
            }
            return !paymentExists;
        } else {
            try {
                const currentPeriod = data.data[getNumberFiliereActif];
                const visibleSousCriteres = getVisibleSousCritereEntries(currentPeriod)
                    .filter(({ critere }) => Number(critere?.id) !== 50);

                for (const { sousCritere } of visibleSousCriteres) {
                    if (Number(sousCritere?.pourcentage) !== 100) {
                        dis = true;
                    }
                }
            } catch (e) {
                //console.error("Erreur attrapée:", e);
            }
            return dis;
        }
    }

    useEffect(() => {
        async function updateButtonState() {
            const disabled = await disabledBoutonSoumission();
            setIsDisabled(disabled);
        }
        updateButtonState();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [getMainActifNum, getNumberSousCritereActif, getNumberFiliereActif, getNumberCritereActif, data, paymentExists]); // Déclenche l'effet quand `getMainActifNum` ou `token` changent


    useEffect(() => {
        if (getMainActifNum !== 1) return;
        if (data == null || !data.data || data.data.length <= getNumberFiliereActif) return;

        const updatedData = updatePercentage(data.data, data);
        const nextCriteres = updatedData.data[getNumberFiliereActif].criteres.map(critere => ({
            id: critere.id,
            nom: critere.nom,
            sousCriteres: critere.sousCriteres.map(sc => ({
                id: sc.id,
                nom: sc.nom,
                pourcentage: sc.pourcentage,
                filtres: sc.filtres
            }))
        }));

        if (JSON.stringify(criteres) !== JSON.stringify(nextCriteres)) {
            setCriteres(nextCriteres);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data, criteres, getMainActifNum, getNumberFiliereActif, updatePercentage]);

    useLayoutEffect(() => {
        if (data != null) {
            if (data.data && data.data.length > getNumberFiliereActif) {
                const updatedData = updatePercentage(data.data, data);
                if (JSON.stringify(data) !== JSON.stringify(updatedData)) {
                    setData(updatedData);
                }
                const currentPeriod = updatedData.data[getNumberFiliereActif];
                const visibleEntries = getVisibleSousCritereEntries(currentPeriod);
                const selectedEntry = visibleEntries.find(({ critereIndex, sousCritereIndex }) => (
                    critereIndex === getNumberCritereActif && sousCritereIndex === getNumberSousCritereActif
                ));
                const nextEntry = visibleEntries.find(({ critereIndex, sousCritereIndex }) => (
                    critereIndex > getNumberCritereActif
                    || (critereIndex === getNumberCritereActif && sousCritereIndex > getNumberSousCritereActif)
                ));
                const fallbackEntry = selectedEntry || nextEntry || visibleEntries[visibleEntries.length - 1];

                if (fallbackEntry) {
                    if (
                        fallbackEntry.critereIndex !== getNumberCritereActif
                        || fallbackEntry.sousCritereIndex !== getNumberSousCritereActif
                    ) {
                        setNumberCritereActif(fallbackEntry.critereIndex);
                        setNumberSousCritereActif(fallbackEntry.sousCritereIndex);
                    }

                    setSouscritere((fallbackEntry.sousCritere.questions || []).map(question => ({
                        ...question
                    })));
                } else {
                    setSouscritere([]);
                }
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data, getNumberFiliereActif, getNumberCritereActif, getNumberSousCritereActif, updatePercentage]); // Removed sendDataToServer


    /* ---  GESTION DES MISES À JOUR DES DIFFÉRENTS TYPES DE CHAMPS --- */


    //Par défaut
    const updateQuestionValue = (
        sousCritereIndex,
        questionIndex,
        newValue,
        valideFormat = null,   // ⬅️ nouveau paramètre
        valideFormatConfirm = null
    ) => {
        // Part du dernier état connu et non de celui du rendu : appelée après
        // un `await` (téléversement, vérification de fichier), la copie du
        // rendu est périmée et la remettre en place effaçait les réponses et
        // les sous-critères vus entre-temps.
        const updatedData = { ...(dataRef.current || data) };

        const question =
            updatedData
                .data[getNumberFiliereActif]
                .criteres[getNumberCritereActif]
                .sousCriteres[sousCritereIndex]
                .questions[questionIndex];

        question.value = newValue;

        // Le candidat modifie sa réponse : le refus du CRM portait sur
        // l'ancienne valeur, il n'a plus lieu d'être affiché.
        if (question.salesforceError) {
            delete question.salesforceError;
        }

        if (valideFormat !== null) {
            setQuestionBaseValideFormat(question, valideFormat);
            question.valideFormat = valideFormat; // ⬅️ ici on écrit dans le JSON
        }
        if (valideFormatConfirm !== null) {
            question.valideFormatConfirm = valideFormatConfirm;
        }

        applyDistinctContactEmailValidation(updatedData);

        setSouscritere(
            updatedData
                .data[getNumberFiliereActif]
                .criteres[getNumberCritereActif]
                .sousCriteres[sousCritereIndex]
                .questions
        );

        setData(updatedData);
        // REMOVED: sendDataToServer(updatedData, getMainActifNum);
        return updatedData;
    };

    //Pour les champs de recherche (villes, lycées...)
    const updateQuestionSearch = (sousCritereIndex, questionIndex, newValue, newCode, newValueName) => {
        setData((prev) => {
            if (!prev || !prev.data) return prev;
            const updatedData = { ...prev };
            const question = updatedData
                .data[getNumberFiliereActif]
                .criteres[getNumberCritereActif]
                .sousCriteres[sousCritereIndex]
                .questions[questionIndex];

            if (!question) return prev;

            question.value = newValue;
            question.code_postal = newCode;
            question.valueName = newValueName;
            // La réponse change : le refus du CRM ne s'applique plus.
            if (question.salesforceError) {
                delete question.salesforceError;
            }
            return updatedData;
        });
        // REMOVED: sendDataToServer(updatedData, getMainActifNum);
    };

    //Pour les champs de recherche (villes, lycées...)
    const updateQuestionSelectPays = (sousCritereIndex, questionIndex, newValue, newCode) => {
        setData((prev) => {
            if (!prev || !prev.data) return prev;
            const updatedData = { ...prev };
            const question = updatedData
                .data[getNumberFiliereActif]
                .criteres[getNumberCritereActif]
                .sousCriteres[sousCritereIndex]
                .questions[questionIndex];

            if (!question) return prev;

            question.value = newValue;
            question.code = newCode;
            // La réponse change : le refus du CRM ne s'applique plus.
            if (question.salesforceError) {
                delete question.salesforceError;
            }
            return updatedData;
        });
        // REMOVED: sendDataToServer(updatedData, getMainActifNum);
    };

    //Pour les champs de recherche (villes, lycées...)
    const updateFiltreGeneral = (ValueFiltre, indexFiltre) => {
        setData((prev) => {
            if (!prev || !prev.data) return prev;
            const updatedData = { ...prev };
            updatedData.data[getNumberFiliereActif].filtres[indexFiltre] = ValueFiltre;
            return updatedData;
        });
        // REMOVED: sendDataToServer(updatedData, getMainActifNum);
    };

    //Mise à jour de la consultation des questions (vue ou pas vue)
    const updateQuestionVue = (critereIndex, sousCritereIndex) => {
        setData((prev) => {
            if (!prev || !prev.data) return prev;
            const updatedData = { ...prev };
            try {
                updatedData.data[getNumberFiliereActif]
                    .criteres[critereIndex]
                    .sousCriteres[sousCritereIndex]
                    .vue = true;
            } catch {
            }
            return updatedData;
        });
        // REMOVED: sendDataToServer(updatedData, getMainActifNum);
    };

    const updateQuestionVisible = (critereIndex, sousCritereIndex, questionIndex, visible) => {

        setData((prev) => {
            if (!prev || !prev.data) return prev;
            const updatedData = { ...prev };
            try {
                //console.log(typeof visible, visible); // Doit afficher "boolean false"
                const question = updatedData.data[getNumberFiliereActif]
                    .criteres[critereIndex]
                    .sousCriteres[sousCritereIndex]
                    .questions[questionIndex];
                if (question.visiblepourcentage === visible && question.visible === visible) {
                    return prev;
                }
                question.visiblepourcentage = visible;
                question.visible = visible;
                //console.log(updatedData.data[getNumberFiliereActif].criteres[critereIndex].sousCriteres[sousCritereIndex].questions[questionIndex].visible);
            } catch {
            }
            return updatedData;
        });
        // REMOVED: sendDataToServer(updatedData, getMainActifNum);
        //console.log(data.data[0].criteres[0].sousCriteres[1].questions[7].visible)
    };

    useEffect(() => {
        //console.log("🚀 useEffect triggered! New data:");
        try {
            //console.log(data);
            //console.trace(data.data[0].criteres[0].sousCriteres[1].questions[7].visible)
        } catch {

        }

    }, [data]);

    //                <button id="BoutonSoumission" onClick={generatesendToCrmValue} disabled={disabledBoutonSoumission()}>Soumettre mon dossier</button>


    useEffect(() => {
        const previousLanguage = document.documentElement.lang;
        const previousTitle = document.title;
        document.documentElement.lang = isExchange ? 'en' : (data?.lang || 'fr');
        if (isExchange) document.title = 'ICES · Exchange student registration';
        return () => { document.documentElement.lang = previousLanguage; document.title = previousTitle; };
    }, [isExchange, data?.lang]);


    /* --- GESTION DU TITRE PRINCIPAL (HEADER) --- */
    useEffect(() => {
        const titreElement = document.getElementById("titre");
        if (titreElement) {
            if (isValidatingToken) { titreElement.textContent = ""; return; }
            const isEnglish = langRef.current === "en";
            const baseTitle = isEnglish ? "Application" : "Inscription";

            if (getMainActifNum === 1 || getMainActifNum === 4 || getMainActifNum === 2) {
                titreElement.textContent = isExchange ? "Exchange student registration" : `${baseTitle} : ${niveau} - ${filiere}`;
            } else {
                titreElement.textContent = isExchange ? "Exchange student registration" : baseTitle;
            }
        }
    }, [getMainActifNum, niveau, filiere, data, isExchange, isValidatingToken]);

    /* ------------------------------------------------------------ AFFICHAGE ------------------------------------------------------------ */


    // Pendant la validation du token : ne rien afficher (évite un clignotement
    // de "Dossier étudiant introuvable" avant que la réponse arrive).
    if (isValidatingToken) return null;

    //Si le token n'est pas reconnu
    if (!isAuthorized) {
        return (
            <main id="MenuSelectionFilliere" className={getFiliereActif}>
                <IconSelectionFilere filiereInfo={{
                    "id": -1,
                    "period": "-",
                    "nom": isExchange ? "We could not open your application. Please refresh the page. If the problem persists, contact the academic office." : "Dossier étudiant introuvable. Rechargez la page une première fois. Si vous rencontrez toujours un problème, merci de contacter le service des facultés.",
                    "niveau": "-"
                }} key={0}>

                </IconSelectionFilere>
            </main>);
    } else {
        const dossierSoumis = isDossierSoumis(data);

        if (dossierSoumis && isExchange) {
            return <main className="containerConfirmation exchangeSubmissionConfirmation"><h1>File submitted</h1><p>The administration will now review your file. You will receive an email confirming your enrolment.</p></main>;
        }

        if (dossierSoumis) {
            return (
                <>
                    {renderInformativeMessages(templateMessages.final)}
                </>
            );
        }

        // Candidature : confirmation d'une filière transmise, les autres
        // restent accessibles pour être complétées et envoyées à leur tour.
        if (data?.configuration === 'Candidature' && getMainActifNum === 4
            && data.data?.[getNumberFiliereActif]?.soumis === true) {
            return (
                <>
                    {renderInformativeMessages(templateMessages.final)}
                    <div className="BoutonsNavMain BoutonsNavMain--intro">
                        <button id="BoutonSoumission" onClick={() => { recordNav(); setMainActifNum(0); }}>
                            <p>{langRef.current === "en" ? "Back to my applications" : "Revenir à mes candidatures"}</p>
                        </button>
                    </div>
                </>
            );
        }

        if (!hasValidatedIntroMessages) {
            return (
                <>
                    {isExchange && templateMessagesStatus === 'loading' && <p role="status" className="exchange-intro-message">Loading introductory messages…</p>}
                    {isExchange && templateMessagesStatus === 'error' && <div role="alert" className="exchange-intro-message"><p>We could not load the introductory messages.</p><button onClick={() => setTemplateMessagesAttempt(previous => previous + 1)}>Try again</button></div>}
                    {isExchange ? exchangeIntroduction.intro.map(message => <ExchangeIntroMessage key={message.id} message={message} />) : renderInformativeMessages(templateMessages.intro)}
                    {isExchange && introDialogOpen && <ExchangeIntroDialog value={exchangeIntroduction.confirmation} busy={isSavingIntroValidation} onConfirm={() => handleIntroValidation(true)} onCancel={() => setIntroDialogOpen(false)} />}
                    <div className="BoutonsNavMain BoutonsNavMain--intro">
                        <button
                            id="BoutonSoumission"
                            onClick={handleIntroValidation}
                            disabled={isSavingIntroValidation || !Array.isArray(data?.data) || (isExchange && templateMessagesStatus !== 'ready')}
                        >
                            <p>{langRef.current === "en" ? "Next" : "Suivant"}</p>
                        </button>
                    </div>
                </>
            );
        }

        const currentPeriod = data?.data?.[getNumberFiliereActif];
        const visibleCritereIds = new Set(
            getVisibleSousCritereEntries(currentPeriod).map(({ critere }) => String(critere?.id))
        );

        //Si le token est reconnu
        return (
                <>
                    <div hidden>
                    </div>

                {Array.isArray(data?.data) && !dossierSoumis && (
                    <main id="MenuSelectionFilliere" className={getFiliereActif}>
                        {filieres.map((filiere, index) => (
                            <IconSelectionFilere
                                filiereInfo={filiere}
                                submitted={data.data[index]?.soumis === true}
                                key={index}
                                getMainActifNum={getMainActifNum}
                                setMainActifNum={setMainActifNum}
                                getNumberFiliereActif={getNumberFiliereActif}
                                setNumberFiliereActif={setNumberFiliereActif}
                                data={data}
                                Lang={langRef.current}
                                recordNav={recordNav}
                            />
                        ))}
                    </main>
                )}




                <main id="MenuSelectionCritère" className={getCritereActif}>
                    {criteres.filter(critere => Number(critere.id) !== 50 && visibleCritereIds.has(String(critere.id))).map((critere, index) => (
                        <IconSelectionCritere critereInfo={critere} key={index}
                            getMainActifNum={getMainActifNum}
                            setMainActifNum={setMainActifNum}
                            getNumberFiliereActif={getNumberFiliereActif}
                            setNumberCritereActif={setNumberCritereActif}
                            setNumberSousCritereActif={setNumberSousCritereActif}
                            getSouscritereInfo={souscritereactif}
                            setSouscritereInfo={setSouscritere}
                            data={data}
                            Lang={langRef.current}
                            recordNav={recordNav}
                        />
                    ))}
                </main>

                <main id="MenuSelectionCritère" className={getClassDossierSoumisActif}>
                    <SalesforceGlobalErrors errors={salesforceGlobalErrors} />
                    <div dangerouslySetInnerHTML={{ __html: sendToCrmValue }} />
                </main>

                <Navbar2
                    getBtnRetourActif={getBtnRetourActif}
                    getBtnSoumissionActif={getBtnSoumissionActif}
                    getBtnSoumissionDossier={getBtnSoumissionDossier}
                    getMainActifNum={getMainActifNum}
                    setMainActifNum={setMainActifNum}
                    getNumberFiliereActif={getNumberFiliereActif}
                    setNumberCritereActif={setNumberCritereActif}
                    setNumberSousCritereActif={setNumberSousCritereActif}
                    data={data}
                    isDisabled={isDisabled}
                    mail={mail}
                    candidature={candidature}
                    niveau={niveau}
                    sendToCrmValueOrigin={sendToCrmValue}
                    setsendToCrmValue={setsendToCrmValue}
                    sendDataToServer={sendDataToServer}
                    Lang={langRef.current}
                    token={token}
                    checkPaymentExists={checkPaymentExists}
                    triggerSave={triggerSave}
                    recordNav={recordNav}
                    submitCandidatureToCrm={submitCandidatureToCrm}
                />

                <main id="HomeSousCritere" className={getHomeActif}>
                    {/* Également affiché ici : après un refus mixte, le candidat
                        est ramené au formulaire et doit voir les motifs qu'il ne
                        peut pas corriger lui-même. */}
                    <SalesforceGlobalErrors errors={salesforceGlobalErrors} />
                    <HomeSousCritere
                        souscritereInfo={souscritereactif}
                        getMainActifNum={getMainActifNum}
                        setMainActifNum={setMainActifNum}
                        getNumberFiliereActif={getNumberFiliereActif}
                        getNumberCritereActif={getNumberCritereActif}
                        setNumberCritereActif={setNumberCritereActif}
                        getNumberSousCritereActif={getNumberSousCritereActif}
                        setNumberSousCritereActif={setNumberSousCritereActif}
                        criteres={criteres}
                        updateQuestionValue={updateQuestionValue}
                        updateQuestionVue={updateQuestionVue}
                        updateQuestionVisible={updateQuestionVisible}
                        updateFiltreGeneral={updateFiltreGeneral}
                        updateQuestionSearchCode={updateQuestionSearch}
                        updateQuestionSelectPays={updateQuestionSelectPays}
                        sendDataToServer={sendDataToServer}
                        etudiant={etudiant}
                        data={data}
                        filiere={filiere}
                        estimationTestSelection={estimationTestSelection}
                        setEstimationTestSelection={setEstimationTestSelection}
                        isEstimationTestWindowOpen={isEstimationTestWindowOpen}
                        Lang={langRef.current}
                        setQuestionValueToTrue={setQuestionValueToTrue}
                        isDisabled2={isDisabled}
                        checkPaymentExists={checkPaymentExists}
                        paymentExists={paymentExists}
                        triggerSave={triggerSave}
                        recordNav={recordNav}
                    />
                </main>

            </>
        );
    }
}

export default App;

//git add .
//git commit -m main_2026_base
//git push origin main_2026
